module.exports = __webpack_public_path__ + "static/media/lungdis_help2688.92b19334.png";